import React, { Component } from 'react';
import {
    Nav, NavDropdown, MenuItem
} from 'react-bootstrap';

import { PROD } from 'services/ConfigService.jsx'

import { Authenticator, Logout } from 'services/AuthService.jsx'
import { FeatureFlags } from 'services/FeatureFlagsService.jsx'
import { withRouter } from 'react-router-dom';
import { EventBus, EVENT_TYPE } from 'services/EventService.jsx'
import { ProjectAPI } from 'services/ApiService.jsx';
import { CACHE } from 'services/DataService.jsx';

import NotificationSystem from 'react-notification-system';
import { style } from "variables/Variables.jsx";

import Log from 'services/Log.jsx'



class HeaderLinks extends Component{

  constructor(props){
    super(props);
    this.state = {
      selected_project : {},
      projects: [],
      navigate: "",
      _notificationSystem: null,
      cache_control: false
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.showVerifyEmail = this.showVerifyEmail.bind(this);
  }
  requestVerifyEmail() {
      Authenticator.requestVerifyEmail((response) => {
          Log.debug("[requestVerifyEmail] " + JSON.stringify(response));
      });
  }
  getToken(props) {
      if (props.location.search.includes("verify_email")) {
        let matches = props.location.search.match(/verify_email=([^&]*)/);
        if (matches.length > 1) {
            return matches[1];
        }
      }
      return null;
  }
    showVerifyEmail() {
      Log.debug("[HL]: " + JSON.stringify(this.props));
        let token = this.getToken(this.props);
        var level = '';
        var position = '';
        if (token !== null) {
            Authenticator.verifyEmail(token, (response) => {
                if (response.success) {
                    level = 'success';
                    position = 'tc';
                    if (this.state._notificationSystem) {
                        this.state._notificationSystem.addNotification({
                            title: (<span data-notify="icon" className="pe-7s-gift"></span>),
                            message: (
                                <div>
                                    Thank you for verifying your email.
                                </div>
                            ),
                            level: level,
                            position: position,
                            autoDismiss: 0
                        });
                    }
                } else {
                    level = 'warning';
                    position = 'tc';
                    if (this.state._notificationSystem) {
                        this.state._notificationSystem.addNotification({
                            title: (<span data-notify="icon" className="pe-7s-gift"></span>),
                            message: (
                                <div>
                                    Error validating email, please try again.
                                </div>
                            ),
                            level: level,
                            position: position,
                            autoDismiss: 0
                        });
                    }
                }
            });
        } else {
            level = 'warning';
            position = 'tc';
            if (this.state._notificationSystem && PROD) {
                this.state._notificationSystem.addNotification({
                    title: (<span data-notify="icon" className="pe-7s-gift"></span>),
                    message: (
                        <div>
                            Seems like you haven't verified your email yet. <button
                            onClick={this.requestVerifyEmail}>Click here</button> to send the request
                            again!
                        </div>
                    ),
                    level: level,
                    position: position,
                    autoDismiss: 0
                });
            }
        }
    }

  componentWillMount(props) {
    EventBus.subscribeToEvents(EVENT_TYPE.USER_DATA, () => {
      this.refreshData();
    }, "headerLinks");
  }

  componentWillUnmount(props) {
    EventBus.unsubscribeFromEvents(EVENT_TYPE.USER_DATA, "headerLinks");
  }

  refreshData() {
    Authenticator.getUser((user) => {
        Log.debug("[RD] " + JSON.stringify(user));
        var cache_control = false;
        if (FeatureFlags.isEnabled(FeatureFlags.FLAGS.CLEAR_MA_CACHE)) {
          cache_control = true;
        }
        if (!user.verified) {
            this.showVerifyEmail();
        }
      this.setState({selected_project: user.selectedProject, cache_control: cache_control});
    });
    Authenticator.getProjects((projects) => {
      this.setState({projects: projects});
    });
  }

  clearCache() {
    CACHE.CLEAR();
  }

  componentDidMount(props) {
    this.setState({_notificationSystem: this.refs.notificationSystem});
    this.refreshData();
  }

    handleSelect(event, eventKey) {
      Log.debug(event);
      if (event === 4.5) {
        Authenticator.signout(() => {});
      } else if (event === "create_project") {
        this.props.history.push("/project-wizard");
      } else if (event && event.startsWith("project_")) {
        var projectId = event.split("_")[1];
        ProjectAPI.selectProject(projectId, () => {
          Authenticator.refreshUser((user) => {
            this.refreshData();
          });
        });
      }
    };

    render(){
        return(
            <div>
                <NotificationSystem ref="notificationSystem" style={style}/>
                <Nav pullLeft onSelect={this.handleSelect}>
                  <NavDropdown
                      eventKey={5}
                      title={(
                          <div>
                              <p className="selected-project">
                                  Project: {this.state.selected_project.name}
                                  <b className="caret"></b>
                              </p>
                          </div>
                      )} noCaret id="basic-nav-dropdown-1">
                      {this.state.projects.map((project) =>{
                        return <MenuItem eventKey={"project_" + String(project.id)} key={project.id}>
                          {project.name}
                        </MenuItem>
                      })}
                      <MenuItem divider />
                      <MenuItem eventKey={"create_project"}>Create Project</MenuItem>
                  </NavDropdown>
                </Nav>
                <Nav pullRight onSelect={this.handleSelect}>
                    <NavDropdown
                        eventKey={4}
                        title={(
                            <div>
                                <i className="fa fa-list"></i>
                                <p className="hidden-md hidden-lg">
                                    More
                                    <b className="caret"></b>
                                </p>
                            </div>
                        )} noCaret id="basic-nav-dropdown-3" bsClass="dropdown-with-icons dropdown">
                        <MenuItem onClick={this.clearCache} className={this.state.cache_control ? '' : 'hidden'}><div className="text-warning"><i className="pe-7s-close-circle"></i> Clear Cache</div></MenuItem>
                        <Logout/>
                    </NavDropdown>
                </Nav>
            </div>
        );
    }
}
export default withRouter(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx